import React from "react";
import AdminAddNewProduct from "../../componets/AdminComponents/product/AdminAddNewProduct";
import Navbar from "./Navbar";

const AdminAddProduct = () => {
  return (
    <div>
      <Navbar />
      <AdminAddNewProduct />
    </div>
  );
};

export default AdminAddProduct;
